import { Button } from '@antimatterhq/ui/components/button';
import { Icon } from '@antimatterhq/ui/components/icon';
import { Text } from '@antimatterhq/ui/components/typography';

export function QueryPreQueryInfo() {
  return (
    <div className="flex flex-grow" data-testid="query-no-query">
      <div className="flex flex-1 flex-col items-center gap-2 pt-[100px] text-center">
        <Icon
          icon="heroicons:magnifying-glass"
          className="h-[100px] w-[100px] text-gray-500 dark:text-gray-400"
        />
        <Text className="text-gray-500 dark:text-gray-400" bold size="lg">
          How to search
        </Text>
        <div className="flex gap-4 pt-10">
          <Button>View documentation</Button>
          <Button>Watch tutorial</Button>
        </div>
      </div>
      <div
        className="hidden w-px self-stretch bg-gray-200 dark:bg-grey-650 sm:block"
        data-testid="query-no-query-divider"
      ></div>
      <div className="flex flex-1 flex-col items-center gap-2 pt-[100px] text-center">
        <Icon
          icon="lucide:box-select"
          className="h-[100px] w-[100px] text-gray-500 dark:text-gray-400"
        />
        <Text className="text-gray-500 dark:text-gray-400" bold size="lg">
          No results available
        </Text>
        <Text className="text-gray-500 dark:text-gray-400">
          Run your query to show results
        </Text>
      </div>
    </div>
  );
}
